export * from './app-pdf.component';



// WEBPACK FOOTER //
// ./src/app/components/app-pdf/index.ts